<script lang="ts" setup>
    defineProps<{ type: 'error' | 'warning' }>();
</script>

<template>
    <section
        :class="{
            note: true,
            error: type === 'error',
            warning: type === 'warning'
        }"
    >
        <img
            src="~/assets/icons/warning.svg"
            alt=""
            aria-hidden="true"
            class="icon"
        />

        <div>
            <slot />
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .note {
        border-width: 1px;
        border-style: solid;
        border-radius: var(--border-radius);
        padding: var(--spacing);
        white-space: pre-line;
        hyphens: auto;
        overflow-wrap: anywhere;
        display: flex;
        gap: var(--spacing);
        width: 100%;
    }

    .icon {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
    }

    .error {
        border-color: var(--error);
        background-color: var(--error-notification-background);
    }

    .warning {
        border-color: var(--warning);
        background-color: var(--warning-notification-background);
    }
</style>
